// Drafts live only in this browser tab's memory. Never store access tokens here.
const drafts = new Map();
let warningActive = false;

const warnBeforeLeaving = (event) => {
  event.preventDefault();
  event.returnValue = "";
};

function updateWarning() {
  if (typeof window === "undefined") return;
  if (drafts.size && !warningActive) {
    window.addEventListener("beforeunload", warnBeforeLeaving);
    warningActive = true;
  } else if (!drafts.size && warningActive) {
    window.removeEventListener("beforeunload", warnBeforeLeaving);
    warningActive = false;
  }
}

export const bidDraftKey = (userId, projectId, scope) => JSON.stringify([
  userId, projectId, scope.asset_id, scope.delivery_day, scope.trading_market,
]);

export const readBidDraft = (key) => drafts.get(key);

export function rememberBidDraft(key, draft) {
  // Updating insertion order lets a remounted project recover its latest draft scope.
  drafts.delete(key);
  drafts.set(key, draft);
  updateWarning();
}

export function forgetBidDraft(key, expectedDraft) {
  const current = drafts.get(key);
  // A save finishing after navigation must not erase newer edits in another mount.
  if (expectedDraft && current && (
    JSON.stringify(current.orders) !== JSON.stringify(expectedDraft.orders) ||
    JSON.stringify(current.baseline) !== JSON.stringify(expectedDraft.baseline)
  )) return;
  drafts.delete(key);
  updateWarning();
}

export function lastBidDraftScope(userId, projectId) {
  let scope;
  drafts.forEach((draft) => {
    if (draft.userId === userId && draft.projectId === projectId) scope = draft.scope;
  });
  return scope;
}

export function clearBidDrafts() {
  drafts.clear();
  updateWarning();
}
